<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else>

        <h2 class="references-header">Каталог книг</h2>
        <hr class="my-4"/>

        <filter-by-tags v-model="selectedTag" 
                        :options="parentTags" />

        <hr class="my-4"/>

        <b-row v-if="!standardsBooks || !standardsBooks.length" 
               class="m-0 center filter-by-tags-stub-label">
            Сначала Вы должны выбрать группу тегов и тег
        </b-row>

        <help-viewer v-else :options="standardsBooks"/>

    </b-container>
</template>
<script>
import '@/assets/styles/client/help/help.css'

import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import HelpViewer from '@/components/client/help/HelpViewer'
import FilterByTags from '@/components/client/tags/FilterByTags' 

export default {
    data: function() {
        let load = new Loading();
        this.getHelp(load);
        return {
            load: load,
            selectedTag: null,
            parentTags: [],
            subTags: []
        }
    },
    computed: {
        standardsBooks: function() {
            return this.selectedTag ? this.selectedTag.StandardBooks : [];
        }
    },
    methods: {
        getHelp: function(load) {
            load.Calculate(true);

            apiService.Client.Help.GetDependency()
                .then(response => {
                    this.parentTags = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        HelpViewer,
        FilterByTags
    }
    
}
</script>